import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Text, Tooltip, factory, useProps } from "@components/mantine";
import { useRef, useState } from "react";
import { useSourceIdentityContext } from "../SourceIdentityContext.js";
var defaultProps = {};
// @todo: [CTCORE-10030] Creating a generic TextEllipsis component in Plasma
export var SourceIdentityName = factory(function(_props, ref) {
    var _ref = useProps("SourceIdentityName", defaultProps, _props), maw = _ref.maw, props = _object_without_properties(_ref, [
        "maw"
    ]);
    var _$ref = useSourceIdentityContext(), getStyles = _$ref.getStyles, name = _$ref.name;
    var _$ref1 = _sliced_to_array(useState(false), 2), showTooltip = _$ref1[0], setShowTooltip = _$ref1[1];
    var textRef = useRef(null);
    if (!name) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
        ref: ref
    }, props), {
        maw: maw !== null && maw !== void 0 ? maw : 240,
        flex: 1,
        onMouseEnter: function() {
            if (textRef.current && textRef.current.scrollWidth > textRef.current.clientWidth) {
                setShowTooltip(true);
            }
        },
        onMouseLeave: function() {
            return setShowTooltip(false);
        },
        children: /*#__PURE__*/ _jsx(Tooltip, _object_spread_props(_object_spread({
            label: name
        }, getStyles("name")), {
            opened: showTooltip,
            children: /*#__PURE__*/ _jsx(Text, {
                ref: textRef,
                truncate: "end",
                children: name
            })
        }))
    }));
});
SourceIdentityName.displayName = "@resourceIdentity/source/SourceIdentity/Name";

//# sourceMappingURL=SourceIdentityName.js.map